import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "../views/LoginPages/LoginPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/HomeLandingPages/HomeLandingPage.vue"),
    children: [],
  },
  {
    path: "/ReportIssue",
    name: "ReportIssue",
    component: () => import("../views/HomeLandingPages/ReportIssue.vue"),
  },
  {
    path: "/IONUPLOAD",
    name: "IONUPLOAD",
    component: () => import("../views/HomeLandingPages/IonUpload.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
